import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { Rail } from "@circle-react-uikit/Rail";

interface RailBarPortalProps {
  position?: "header" | "content" | "portal" | "drawer";
  children: ReactNode;
  shouldShowRailBar?: boolean;
  [key: string]: unknown;
}

export const RailBarPortal = ({
  position = "header",
  children,
  shouldShowRailBar = true,
  ...props
}: RailBarPortalProps) => {
  const selectorQuery = `#rail-bar-${position}`;
  const portalElement = document.querySelector(selectorQuery);
  if (!portalElement) {
    return null;
  }

  if (!shouldShowRailBar) {
    return null;
  }

  return (
    <>
      {createPortal(
        <Rail shouldHideRailbarDragger {...props}>
          {children}
        </Rail>,
        portalElement,
      )}
    </>
  );
};
